module.exports = {
  homePage:'/login',
  serverTimeout: 10000,
  token: "token",//全局sessionStorage中存放用户TOKEN的变量名称
  userKey: "userKey",//全局sessionStorage中存放用户主键的变量名称
  userCode: "userCode",//全局sessionStorage中存放用户编码的变量名称
  userName: "userName",//全局sessionStorage中存放用户姓名的变量名称
  userObj: "userObj",//全局sessionStorage中存放用户对象的变量名称
  openId:'openId',//存储微信openId的变量
  fileType:'wps|et|ofd|7z|aiff|asf|avi|bmp|csv|doc|fla|flv|gif|gz|gzip|jpeg|jpg|mid|mov|mp3|mp4|mpc|mpeg|mpg|ods|odt|pdf|png|ppt|pxd|qt|ram|rar|rm|rmi|rmvb|rtf|sdc|sitd|swf|sxc|sxw|tar|tgz|tif|tiff|txt|vsd|wav|wma|wmv|xls|xml|zip|mod|bar|mif|ifg|mel|bin|zk|idx|xlsx|docx|apk|DOC|DOCX|XLS|XLSX|GIF|PDF ',//文件上传允许类型
}




// WEBPACK FOOTER //
// ./src/config/global.js